import '@mdi/font/css/materialdesignicons.css';

import 'vuetify/styles';
import { createVuetify } from 'vuetify';
import { aliases, mdi } from 'vuetify/iconsets/mdi';

import DayJsAdapter from '@date-io/dayjs';

const e360Theme = {
  dark: false,
  colors: {
    primary: '#2E3C54',
    accentOrange: '#FF6E52',
    warning: '#FF6E52',
    charcoal: '#45484D',
    eerieBlack: '#18191A',
    intechBlue: '#21AAD4',
    heatColor: '#B05FA1',
    background: '#F8FCFF',
    aliceBlue: '#F8FCFF',
    greenGraph: '#62BE37',
    sonicSilver: '#737880',
    purpleGraph: '#CC00ED',
    disabled: '#E0E0E0',
    solarYellow: '#ffd600',
    electricGreen: '#779E90',

    daikin: '#00CDFF',
  },
};

export default createVuetify({
  date: {
    adapter: DayJsAdapter,
  },
  // Preserve the Vuetify 3 breakpoint thresholds. Vuetify 4 lowers the
  // defaults (md 960->840, lg 1280->1145, xl 1920->1545, xxl 2560->2138),
  // which would shift the app's responsive behavior.
  display: {
    thresholds: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
      xxl: 2560,
    },
  },
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
    },
  },
  theme: {
    defaultTheme: 'e360Theme',
    themes: {
      e360Theme,
    },
  },
});
